import { render, staticRenderFns } from "./message_detail.vue?vue&type=template&id=8eaf9d1e&scoped=true&"
import script from "./message_detail.vue?vue&type=script&lang=js&"
export * from "./message_detail.vue?vue&type=script&lang=js&"
import style0 from "./message_detail.vue?vue&type=style&index=0&id=8eaf9d1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eaf9d1e",
  null
  
)

export default component.exports